<!-- Scanner Input Modal -->
<div class="main-modal bg-dark" *ngIf="!scanCompleted && !isError && !invalidQRError && !showCancleModal">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <div class="d-flex align-items-center justify-content-between">
                    <h5 class="modal-title" id="modal-title">
                        Scan QR Code {{ scannerMode === 'camera' ? 'with Camera' : 'with Scanner' }}
                    </h5>
                    <button type="button" class="btn-close float-end" (click)="closeScanner()" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                
                <!-- Toggle Button -->
                <div class="scanner-toggle-container mt-3">
                    <div class="toggle-buttons">
                        <button 
                            class="toggle-btn" 
                            [class.active]="scannerMode === 'barcode'"
                            (click)="scannerMode !== 'barcode' && toggleScannerMode()"
                            [disabled]="scannerMode === 'barcode'">
                            <i class="ti ti-barcode"></i>
                            QR Scanner
                        </button>
                        <button 
                            class="toggle-btn" 
                            [class.active]="scannerMode === 'camera'"
                            [class.disabled]="!cameraSupported"
                            (click)="scannerMode !== 'camera' && cameraSupported && toggleScannerMode()"
                            [disabled]="scannerMode === 'camera' || !cameraSupported">
                            <i class="ti ti-camera"></i>
                            Camera
                        </button>
                    </div>
                </div>
            </div>
            
            <div class="modal-body rounded px-4 pb-4 pt-0">
                <!-- Barcode Scanner Interface -->
                <div *ngIf="scannerMode === 'barcode'" class="scanner-container text-center">
                    <!-- Hidden input field for barcode scanner -->
                    <input 
                        #scannerInput
                        id="scannerInput"
                        type="text" 
                        class="scanner-input"
                        (input)="onScannerInput($event)"
                        placeholder="Position cursor here and scan QR code"
                        autocomplete="off"
                        style="opacity: 0; position: absolute; left: -9999px;">
                    
                    <!-- Visual scanning interface -->
                    <div class="scanner-visual-container">
                        <div class="scanner-icon-container">
                            <i class="ti ti-qrcode scanner-icon"></i>
                            <div class="scanner-animation"></div>
                        </div>
                        <h6 class="scanner-title">Ready to Scan</h6>
                        <p class="scanner-instruction">
                            Point your QR scanner at the QR code and scan
                        </p>
                        <div class="scanner-status">
                            <div class="status-dot active"></div>
                            <span>Scanner Active</span>
                        </div>
                    </div>
                </div>

                <!-- Camera Scanner Interface -->
                <div *ngIf="scannerMode === 'camera'" class="scanner-section">
                    <div class="scanner-frame-container position-relative">
                        <div *ngIf="cameraLoading" class="camera-loading-overlay">
                            <div class="camera-loading-content">
                                <div class="camera-loader-ring"></div>
                                <p class="camera-loader-text">Starting camera...</p>
                            </div>
                        </div>
                        <zxing-scanner [device]="currentDevice" (scanSuccess)="handleQrCodeResult($event)" (camerasFound)="onCameraStart()"
                            class="scanner-video w-100" [enable]="scannerEnabled">
                        </zxing-scanner>

                        <!-- Stylish scanner frame overlay -->
                        <div class="scanner-frame">
                            <div class="scanner-corners">
                                <div class="corner top-left"></div>
                                <div class="corner top-right"></div>
                                <div class="corner bottom-left"></div>
                                <div class="corner bottom-right"></div>
                            </div>
                            <div class="scanner-line"></div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Success Modal - Visitor Card -->
<div *ngIf="scanCompleted && !isError" class="main-modal success-main-modal">
    <div class="success-modal-content rounded-4 p-4">
        <div class="modal-body card-padding success-modal-body">
            <div class="close-flip-container d-flex justify-content-between align-items-center">

        <!-- LEFT SIDE → Close Button  -->
        <button class="btn-close button-animations me-2" type="button" (click)="closeVisitorCard()">
        </button>
        
        <!-- RIGHT SIDE → Close + Flip -->
        <div class="d-flex align-items-center" style="gap: 10px;">        
            <!-- Download Button -->
            <button class="btn d-flex align-items-center button-animations download-btn" title="Print Digi Pass"
                id="btn-new-event" (click)="printVisitorCard()">
                <i class="bi bi-printer fs-5"></i>
            </button>        
            <!-- Flip Button -->
            <button class="flip-icon button-animations" (click)="flipCard()" title="Flip"
                [ngClass]="{ 'flip-right': frontSide, 'flip-left': backSide }" [disabled]="imageLoading">
                <i class="ti ti-refresh"></i>
            </button>        
        </div>
      </div>
            <div *ngIf="imageLoading" class="skeleton-card">
        <div class="card-header" style="position: relative;">
          <div class="skeleton skeleton-header"></div>
        </div>
        
        <div class="success-profile-section">
          <div class="skeleton skeleton-text subtitle"></div>
          <div class="skeleton skeleton-avatar"></div>
          <div class="skeleton skeleton-text title"></div>
          <div class="skeleton skeleton-text short"></div>
        </div>
        
        <div class="details-section">
          <div class="row">
            <div class="col-1"></div>
            <div class="col-10">
              <div class="skeleton skeleton-text line"></div>
              <div class="skeleton skeleton-text line"></div>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      </div>
            <div [@flipCard]="cardState" style="transform-style: preserve-3d;" *ngIf="!imageLoading">
                <!-- Front Side Card -->
                <div id="printFrontCard" class="sucess-visitor-card front" [ngClass]="{'VIP-border': visitDetails.visitPurpose.purposeType === 'VIP'}" [hidden]="!frontSide">
                    <div class="card-header">
                        <div class="green-strip-container hide-strip" *ngIf="visitDetails.visitPurpose.purposeType !== 'VIP'">
                            <img src="assets/images/green-strip.svg" alt="Green Strip" class="green-strip" />
                            <div class="white-dot"></div>
                        </div>
                        <div class="green-strip-container hide-strip" *ngIf="visitDetails.visitPurpose.purposeType === 'VIP'">
                            <img src="assets/images/golden-strip.svg" alt="Green Strip" class="green-strip" />
                            <div class="white-dot"></div>
                        </div>
                        <div class="ribbon" [ngClass]="{'VIP-ribbon': visitDetails.visitPurpose.purposeType === 'VIP'}">VISITOR</div>
                    </div>

                    <div class="success-profile-section" [ngClass]="{'overstayed-profile-section': visitDetails.overstay }">
                        <span class="welcome-text">Welcome to {{hostDetails.companyProfile.name}} </span>
                        <div class="profile-image-container" [ngClass]="{'VIP-image': visitDetails.visitPurpose.purposeType === 'VIP'}">
                            <img [src]="visitDetails.photoUrl" alt="Visitor" class="image-profile">
                        </div>
                        <div class="d-flex">
                            <h2 class="visitor-name long-name-ellipsis-1">{{visitDetails.visitor.firstName}}
                                {{visitDetails.visitor.lastName}}</h2>
                            <img [src]="getStatusIcon(visitDetails.visitStatus).icon" [title]="getStatusIcon(visitDetails.visitStatus).tooltip"
                                alt="Status Icon" class="status-icon">
                        </div>
                        <div class="detail-group justify-content-center">
                            <i class="ti ti-map-pin"></i>
                            <span class="detail-text">{{ visitDetails.visitLocation?.location || visitDetails.otherLocationName }}</span>
                        </div>
                    </div>

                    <div class="details-section" [ngClass]="{'overstayed-details-section': visitDetails.overstay }">
                        <div class="overstay-section"
                            *ngIf="visitDetails.visitStatus === 'Checked_In' && visitDetails.overstay || visitDetails.visitor?.isBlacklist && visitDetails.overstay">
                            <img title="Overstayed" alt="Overstayed Icon" class="status-icon m-0" src="assets/icons/liveRedDot.gif">
                            <span class="detail-text overstay-text">
                                <strong>Overstayed{{ getOverstayDuration(visitDetails) ? ' by ' + getOverstayDuration(visitDetails) : ''
                                    }}</strong>
                            </span>
                        </div>
                        <div class="row">
                            <div class="col-7 left-detail-section pe-1">
                                <div class="detail-group mb-2 mt-1">
                                    <i class="ti ti-calendar"></i>
                                    <span class="detail-text">{{ visitDetails.visitDate | dateFormat }}</span>
                                </div>
                                <div class="detail-group mb-2">
                                    <i class="ti ti-clock"></i>
                                    <span class="detail-text">{{ getVisitTimeDisplay(visitDetails) }}</span>
                                </div>

                                <!-- <div class="detail-group"
                                    *ngIf="visitDetails.visitStatus === 'Checked_In' && visitDetails.overstay || visitDetails.visitor.isBlacklist && visitDetails.overstay">
                                    <img src="assets/icons/liveRedDot.gif" title="Overstayed" alt="Overstayed Icon" class="status-icon m-0">
                                    <span class="detail-text overstay-text">
                                        <strong>Overstayed{{ getOverstayDuration(visitDetails) ? ' by ' + getOverstayDuration(visitDetails) : ''
                                            }}</strong>
                                    </span>
                                </div> -->

                                <!-- Show Blacklisted Badge if Blacklisted -->
                                <ng-container *ngIf="visitDetails.visitor.isBlacklist; else visitPurposeBlock">
                                    <span class="visit-tag blacklisted-tag mt-2">Blacklisted</span>
                                </ng-container>

                                <!-- Else Show Purpose / VIP Badge -->
                                <ng-template #visitPurposeBlock>
                                    <ng-container *ngIf="visitDetails?.visitPurpose?.purposeType === 'VIP'; else normalVisitType">
                                        <img src="assets/images/profile/vip.png" alt="VIP Visitor" class=" vip-badge">
                                    </ng-container>
                                    <ng-template #normalVisitType>
                                        <span [ngClass]="getVisitTypeClass(visitDetails.visitPurpose.purposeType)" class="visit-tag">{{
                                            visitDetails.visitPurpose.purposeType
                                            }}</span>
                                    </ng-template>
                                </ng-template>
                            </div>
                            <div class="col-5 qr-detail-section d-flex justify-content-end align-items-center">
                                <img [src]="visitDetails.qrCodeUrl" alt="QR Code" class="img-fluid" style="width: 100px;"
                                    [ngClass]="{'VIP-Qr': visitDetails.visitPurpose.purposeType === 'VIP'}">
                            </div>
                            </div>
                    </div>

                    <div class="digipass-footer-1" style="text-align: center;">
                        <!-- <p class="mb-0">Hosted by <strong>{{visitDetails.hostName}}</strong></p> -->
                        <div class="host-name">
                            <span class="host-label">Hosted by </span>
                            <strong class="host-name-text" [title]="visitDetails.hostName">
                                {{ visitDetails.hostName }}
                            </strong>
                        </div>
                        <hr>
                        <div class="site-link">
                            www.<span class="visitor">visitor</span><span class="bridge">bridge</span>.in
                        </div>
                    </div>
                </div>

                <!-- Back Side Card -->
                <div id="printBackCard" class="sucess-visitor-card back-side-card back" [ngClass]="{'VIP-border': visitDetails.visitPurpose.purposeType === 'VIP'}" [hidden]="!backSide">
                    <div class="card-header">
                        <div class="green-strip-container hide-strip" *ngIf="visitDetails.visitPurpose.purposeType !== 'VIP'">
                            <img src="assets/images/green-strip.svg" alt="Green Strip" class="green-strip" />
                            <div class="white-dot"></div>
                        </div>
                        <div class="green-strip-container hide-strip" *ngIf="visitDetails.visitPurpose.purposeType === 'VIP'">
                            <img src="assets/images/golden-strip.svg" alt="Green Strip" class="green-strip" />
                            <div class="white-dot"></div>
                        </div>
                        <div class="ribbon" [ngClass]="{'VIP-ribbon': visitDetails.visitPurpose.purposeType === 'VIP'}">VISITOR</div>
                    </div>
                    <div class="details-section">
                        <div class="row">
                            <div class="col-12 detail-section-back-container">
                                <!-- Normal Details -->
                                <ng-container *ngIf="!showAssets">
                                    <div class="d-flex flex-column justify-content-between" style="height: 310px;">
                                        <!-- other details -->
                                        <div>
                                            <!-- Email -->
                                            <div class="detail-group mt-2">
                                                <i class="ti ti-mail"></i>
                                                <span class="detail-text">{{ visitDetails.visitor.email || 'Email not provided'}}</span>
                                            </div>

                                            <div class="d-flex justify-content-between">
                                                <!-- Gender -->
                                                <div class="detail-group">
                                                    <i class="ti ti-user"></i>
                                                    <span class="detail-text">
                                                        {{ visitDetails.gender === 'DO_NOT_WANT_TO_SAY'
                                                        ? 'Don\'t want to say'
                                                        : visitDetails.gender.charAt(0) + visitDetails.gender.slice(1).replaceAll('_', ' ').toLowerCase() }}
                                                    </span>
                                                </div>
                                                <!-- Mobile -->
                                                <div class="detail-group">
                                                    <i class="ti ti-device-mobile"></i>
                                                    <span class="detail-text">{{ visitDetails.visitor.mobileNumber }}</span>
                                                </div>
                                            </div>
                                            
                                        
                                            <!-- ID Proof -->
                                            <div class="detail-group">
                                                <i class="ti ti-id"></i>
                                                <span class="detail-text">
                                                    {{ (visitDetails.idProof?.proofType || visitDetails.idNumber)
                                                    ? ((visitDetails.idProof?.proofType || 'Type Not provided') + ' - ' + (visitDetails.idNumber || 'N/A'))
                                                    : 'ID Proof: Not provided' }}
                                                </span>
                                            </div>

                                            <div class="detail-group company-name-container">
                                                <i class="ti ti-building"></i>
                                                <span class="company-name detail-text">{{visitDetails.company || 'Company Name: Not Provided'}}</span>
                                            </div>
                                        
                                            <!-- Vehicle number -->
                                            <div class="detail-group">
                                                <i class="ti ti-car"></i>
                                                <span class="detail-text">{{ visitDetails.vehicleNumber || 'Vehicle Number: Not Provided' }}</span>
                                            </div>
                                            <div class="detail-group" *ngIf="visitDetails.assetDeclarations?.length > 0">
                                                <i class="ti ti-briefcase"></i>
                                                <span *ngIf="!showAssets" (click)="showAssets = true" class="detail-text text-link"
                                                    style="cursor: pointer; text-decoration: None;">
                                                    View Assets
                                                </span>
                                            </div>
                                        </div>
                                            
                                        
                                        <!-- ID Proof Image -->
                                        <div class="id-proof-image mt-2">
                                            <img [src]="visitDetails.idProofUrl || 'assets/images/id-proof-placeholder.svg'" alt="ID Proof" class="img-fluid"
                                                style="max-width: 100%; border-radius: 8px;" />
                                        </div>
                                    
                                        
                                    </div>
                                </ng-container>
                
                                <!-- Assets Section -->
                                <ng-container *ngIf="showAssets">
                                    <div class="assets-section mt-2">
                                        <div class="d-flex justify-content-between mb-3 sticky-top bg-white">
                                            <h5 class="mb-0">Visitor Assets</h5>
                                            <div *ngIf="visitDetails.assetDeclarations">
                                                <span *ngIf="showAssets" (click)="showAssets = false" class="detail-text text-link"
                                                    style="cursor: pointer; text-decoration: underline;">Hide Assets</span>
                                            </div>
                                        </div>
                                        <div class="asset-item mb-3" *ngFor="let asset of visitDetails.assetDeclarations">
                                            <div class="asset-detail-text detail-text">
                                                <div><strong>Asset Type:</strong> {{ asset.assetType?.assetType }}</div>
                                                <div><strong>Brand:</strong> {{ asset.brand }}</div>
                                                <div><strong>Serial:</strong> {{ asset.serialNumber }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                            </div>
                        </div>
                    </div>
                
                    <div class="digipass-footer-1" style="text-align: center;">
                        <hr>
                        <div class="site-link">
                            www.<span class="visitor">visitor</span><span class="bridge">bridge</span>.in
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer gap-3 px-4 py-3 border-0">
            <button *ngIf="visitDetails.visitStatus === 'Scheduled'" class="btn-back button-animations cancel-button" (click)="openCancelModal()">Deny</button>
            <!-- Check-In -->
            <button *ngIf="visitDetails.visitStatus === 'Scheduled'" class="btn close-button button-animations text-white"
                id="btn_check_in" type="button" (click)="checkedInVisit(visitDetails)"
                [ngClass]="{'disabled-button': checkInLoader}">
                {{checkInLoader ? 'Checking In...' : 'Check-In'}}
            </button>

            <!-- Check-Out -->
            <button *ngIf="visitDetails.visitStatus === 'Checked_In'" class="btn close-button button-animations text-white"
                id="btn_check_out" type="button" (click)="checkedOutVisit(visitDetails)" 
                [ngClass]="{'disabled-button': checkOutLoader}">
                {{checkInLoader ? 'Checking Out...' : 'Check-Out'}}
            </button>

        </div>
    </div>
</div>

<!-- Error Modal -->
<div class="main-modal" *ngIf="isError">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="closeScanner()" aria-label="Close"></button>
                <h5 class="modal-title text-danger">QR Scan Error</h5>
            </div>
            <div class="modal-body text-center px-4 pb-4 pt-0">
                <img class="success-tick pb-4" src="assets/icons/Error-cross.png" alt="error-icon">
                <h5 class="card-title pb-4 text-danger">{{ errorMessage }}</h5>
                <button class="btn btn-outline-secondary mt-3" (click)="closeScanner()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Invalid QR Error Modal -->
<div class="main-modal" *ngIf="invalidQRError">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="closeScanner()" aria-label="Close"></button>
                <h5 class="modal-title text-danger">Invalid QR Code</h5>
            </div>
            <div class="modal-body text-center px-4 pb-4 pt-0">
                <img class="success-tick pb-4" src="assets/icons/Error-cross.png" alt="error-icon">
                <h5 class="card-title pb-4 text-danger">Invalid QR code format. Please try again.</h5>
                <button class="btn btn-outline-secondary mt-3" (click)="closeScanner()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Unique QR Modal -->
<div class="main-modal" *ngIf="uniqueQRresult">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="closeScanner()" aria-label="Close"></button>
                <!-- <h5 class="modal-title text-danger">Invalid QR Code</h5> -->
            </div>
            <div class="modal-body text-center px-4 pb-4 pt-0">
                <img class="success-tick pb-4" src="assets/icons/Ghost-Unique.png" alt="error-icon">
                <h5 class="card-title pb-4 text-black">Oops! This QR has already walked out! 🚪</h5>
                <button class="btn btn-outline-secondary mt-3" (click)="closeScanner()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Pending QR Modal -->
<div class="main-modal" *ngIf="pendingQRresult">
    <div class="modal-dialog modal-md">
        <div class="modal-content d-flex flex-column justify-content-between" style="height: 550px;">
            <div class="modal-header py-3 px-4 border-bottom-0 d-block">
                <button type="button" class="btn-close float-end" (click)="closeScanner()" aria-label="Close"></button>
                <!-- <h5 class="modal-title text-danger">Invalid QR Code</h5> -->
            </div>
            <div class="modal-body text-center px-4 py-4">
                <img class="success-tick py-4" src="assets/icons/sleeping-clock.png" alt="error-icon">
                <h5 class="card-title pb-4 text-black">⏳ Approval Pending</h5>
                <h5 class="card-title text-black">A quick nudge to your host might help 🙂</h5>
            </div>
            <div class="modal-footer border-0 justify-content-center pb-4">
                <button class="btn btn-outline-secondary" (click)="closeScanner()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Cancel Confirmation Modal -->
<!-- ALERT FOR DENY REQUEST -->
<div *ngIf="showCancleModal" class="main-modal">
  <div class="modal-main-content request-details-content rounded-4 p-2">
    <div class="modal-header-section d-flex justify-content-end px-4 py-3 rounded-4 modal-lg">
      <button class="btn-close text-end" type="button" (click)="closeCancleModal()"></button>
    </div>

    <div class="modal-body d-flex flex-column align-items-center justify-content-center px-4 py-0">
        <h4>Are you sure you want to deny this visit? If yes, please provide a remark.</h4>
    </div>

    <div class="modal-body d-flex flex-column justify-content-center px-4 py-3 pt-2">
      <div class="row">
        <div class="col-md-12">
          <!-- <label for="remark" class="fw-semibold mb-2">Enter Remark:</label> -->
          <textarea name="remark" [(ngModel)]="accessDenyRemark" (input)="onRemarkInput()" #DenyRemark="ngModel" id="remark" rows="3" class="form-control" placeholder="Enter reason or remark..." 
          required minlength="10" maxlength="250"></textarea>
          <!-- Validation feedback -->
          <div *ngIf="DenyRemark.invalid && (DenyRemark.dirty || DenyRemark.touched)" class="invalid-feedback d-block">
            <div *ngIf="DenyRemark.errors?.['required']" class="text-danger small">
              Remarks/Comments are required
            </div>
            <div *ngIf="DenyRemark.errors?.['minlength']" class="text-danger small">
              Remarks/Comments must be at least 10 characters long
            </div>
            <div *ngIf="DenyRemark.errors?.['maxlength']" class="text-danger small">
              Remarks/Comments cannot exceed 250 characters
            </div>
          </div>
          
          <!-- Character counter -->
          <div class="form-text">
            {{ validRemarkLength }}/250 characters used
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer gap-3 px-4 py-3 border-0 justify-content-center">
      <button type="button" class="no-btn button-animations cancel-button" (click)="closeCancleModal()">Cancel</button>
      <button type="button" class="yes-btn button-animations approve-blacklist-btn"  (click)="accessDeniedVisit(visitDetails.visitId)">
        Deny
      </button>
    </div>
  </div>
</div>
<div *ngIf="isPrinting" class="printing-loader-backdrop">
  <div class="printing-loader-box">
    <img src="assets/images/printer gif.gif" alt="Printing..." class="print-gif" />
    <p class="print-label">Preparing your DigiPass...</p>
    <div class="print-progress">
      <div class="print-progress-bar"></div>
    </div>
  </div>
</div>
